import styles from './PreviewTour.module.css'
import InternalHeader from '../../InternalHeader/InternalHeader'
import {FlatCardData} from '../../CardsComponents/types'

type PreviewTourProps = {
  onClose: () => void;
  flat: FlatCardData;
};

function toHttpsAbsolute(url?: string): string {
  if (!url) return '';
  const trimmed = url.trim();
  const normalizedTourPath = /\/status\/3d-tour\/\d+$/i.test(trimmed) ? `${trimmed}/` : trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  if (/^http:\/\//i.test(trimmed)) return `https://${trimmed.slice('http://'.length)}`;
  if (/^https:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('/')) return `${window.location.origin}${normalizedTourPath}`;
  if (/^vostokstroy\.com/i.test(trimmed)) return `https://${trimmed}`;
  return trimmed;
}

const PreviewTour: React.FC<PreviewTourProps> = ({ onClose, flat }) => {
    const tourSrc = toHttpsAbsolute(flat.preview3DTour);
    return (
      <div className={styles.modal}>
        <InternalHeader title={'Трехмерный тур'} onClose={onClose} />
        {tourSrc ? (
          <iframe
            src={tourSrc}
            width="1280"
            height="670"
            frameBorder="0"
            title="3D Tour Preview"
            className={styles.tour}
          />
        ) : (
          <div className={styles.tourUnavailable}>
            3D тур для этой квартиры недоступен.
          </div>
        )}
      </div>
    );
  };
  
export default PreviewTour;
  
